function page_load(collection_grid) {
    if (sessionStorage.getItem('back_col_url') == window.location.href) {
      collection_grid.innerHTML = sessionStorage.getItem('back_col_html');
      collection_grid.setAttribute('data-next-url', sessionStorage.getItem('back_col_next_url'));
      if (collection_grid.getAttribute('data-next-url') == '') {
        var load_button = document.querySelector(".custom-filter-load-more")
        if(load_button){
            load_button.style.display = 'none'
        }
      }
    }
    sessionStorage.removeItem('back_col_html');
    sessionStorage.removeItem('back_col_url');
    sessionStorage.removeItem('back_col_next_url');
    window.onunload = function () {
      sessionStorage.setItem('back_col_html', collection_grid.innerHTML);
      sessionStorage.setItem('back_col_url', window.location.href);
      sessionStorage.setItem('back_col_next_url', collection_grid.getAttribute('data-next-url'));
    };
}

const activeDogIdStorageKey = 'active_recommendation_dog_id';
const activeDogDailyKcalStorageKey = 'active_recommendation_dog_daily_kcal';

function parsePositiveNumber(value) {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    const normalizedValue = String(value).replace(/,/g, '.').trim();
    const parsedNumber = Number(normalizedValue);
    if (!Number.isFinite(parsedNumber) || parsedNumber <= 0) {
        return null;
    }

    return parsedNumber;
}

function renderProductCardFeedingAmounts(scope = document) {
    if (window.QF && typeof window.QF.renderProductCardFeedingAmounts === 'function') {
        window.QF.renderProductCardFeedingAmounts(scope);
    }
}

function buildCollectionHistoryUrl(baseUrl, filterParams) {
    if (!window.location.pathname.includes('/collections/your-recommendations')) {
        return filterParams ? `${baseUrl}?${filterParams}` : baseUrl;
    }

    const queryParts = [];
    if (filterParams) {
        queryParts.push(filterParams);
    }

    const activeDogId = parsePositiveNumber(localStorage.getItem(activeDogIdStorageKey) || sessionStorage.getItem(activeDogIdStorageKey));
    const activeDogDailyKcal = parsePositiveNumber(localStorage.getItem(activeDogDailyKcalStorageKey) || sessionStorage.getItem(activeDogDailyKcalStorageKey));

    if (activeDogId) {
        queryParts.push(`dogId=${encodeURIComponent(Math.round(activeDogId))}`);
    }

    if (activeDogDailyKcal) {
        queryParts.push(`dogDailyKcal=${encodeURIComponent(Math.round(activeDogDailyKcal))}`);
    }

    if (queryParts.length === 0) {
        return baseUrl;
    }

    return `${baseUrl}?${queryParts.join('&')}`;
}

// Helper to attach Load More handler (must be global for AJAX updates)
function attachLoadMoreHandler() {
    const load_btn = document.querySelector(".custom-filter-load-more");
    const products_on_page = document.querySelector('.collection-grid');
    if (!load_btn || !products_on_page) return;
    let url = products_on_page.getAttribute('data-next-url');
    if (url === '') {
        load_btn.style.display = 'none';
    }
    // Remove previous handler by cloning
    const new_load_btn = load_btn.cloneNode(true);
    load_btn.parentNode.replaceChild(new_load_btn, load_btn);
    new_load_btn.addEventListener("click", function () {
        fetch(url)
            .then(function (response) {
                if (response.ok) {
                    return response.text();
                } else {
                    throw new Error('Network response was not ok.');
                }
            })
            .then(function (data) {
                const html = document.createElement('div');
                html.innerHTML = data;
                let links = html.querySelector('.pagination-links').innerHTML;
                document.querySelector('.pagination-links').innerHTML = links;
                let new_grid = html.querySelector('.collection-grid');
                url = new_grid.getAttribute('data-next-url');
                document.querySelector('.collection-grid').setAttribute('data-next-url',url)
                if (url === '') {
                    new_load_btn.style.display = 'none';
                }
                let new_products = new_grid.querySelectorAll(".product-card, #collection-advert, #collection-advert-2, #collection-advert-3, #collection-advert-4");
                // re-update the product card index to take into account the existing products
                let lastProductIndex = 0;
                document.querySelectorAll(".product-card").forEach(prod => {
                    const index = prod.getAttribute('data-index');
                    if (index) {
                        lastProductIndex = Math.max(lastProductIndex, parseInt(index));
                    }
                });
                let newProductIndex = lastProductIndex + 1;
                new_products.forEach(new_prod => {
                    new_prod.setAttribute('data-index', newProductIndex);
                    products_on_page.append(new_prod);
                    newProductIndex++;
                });
                renderProductCardFeedingAmounts(products_on_page);
                document.dispatchEvent(new Event('loaded_more_products'));
            })
            .catch(function (error) {
                window.log(error);
            });
    });
}

document.addEventListener('DOMContentLoaded', function() {

    const collectionGrid = document.querySelector('.collection-grid');
    
    if (!collectionGrid) {
        return;
    }
    
    // Listen for filter changes from the v3-collection-filters
    document.addEventListener('click', function(e) {
        const target = e.target;
        
        // Check if it's a filter input in the custom-filter-wrapper
        if (target.type === 'checkbox' && target.closest('.custom-filter-wrapper')) {
            setTimeout(() => {
                updateCollectionResults();
            }, 100); // Small delay to ensure checkbox state is updated
        }
    });
    
    // Listen for select changes (sort dropdown)
    document.addEventListener('change', function(e) {
        const target = e.target;
        
        if (target.name === 'sort_by' && target.closest('.custom-filter-wrapper')) {
            updateCollectionResults();
        }
    });

    // Attach on page load
    attachLoadMoreHandler();
    renderProductCardFeedingAmounts(collectionGrid);

    let custom_filters = document.querySelectorAll(".custom-filter")

    custom_filters.forEach((el)=>{

        let control = el.querySelector(".filter-heading")
        let body = el.querySelector(".filter-body")

        if(control && body){


            control.addEventListener('click', () => {

                if (!el.classList.contains("open")) {
                    custom_filters.forEach((el)=>{
                        if(el.classList.contains("open")){
                            el.classList.remove("open")
                        }
                    })
                    el.classList.add("open")
                } else {
                    el.classList.remove("open")
                }


            })
        }
    })

    let mobile_control = document.querySelector(".mobile-filter-heading")
    let filter_body = document.querySelector(".custom-filter-wrapper")
    let promoBar = document.querySelector(".promotional-bar")
    let announcementBar = document.querySelector(".announcement-bar")
    if(mobile_control && filter_body){
        mobile_control.addEventListener('click', () => {
            // rotate svg
            if(mobile_control.classList.contains("open")){
                mobile_control.classList.remove("open")
            } else {
                mobile_control.classList.add("open")
            }

            // open filters
            if(filter_body.classList.contains("open")){
                filter_body.classList.remove("open")
                promoBar.classList.remove("open")
                announcementBar.classList.remove("open")
            } else {
                filter_body.classList.add("open")
                promoBar.classList.add("open")
                announcementBar.classList.add("open")
            }
        })
    }

    // Hide reset filters when no filters active
    const reset_filters = document.querySelector('.reset-filter-wrapper');
    const selected_filters_html = document.querySelectorAll('.selected-filter-wrapper *');

    if (selected_filters_html.length > 0) {
        reset_filters.style.display = 'block';
    }

    const collection_grid = document.querySelector('.collection-grid');

    selected_filters_html.forEach(selected => {
        selected.addEventListener('click', () => {
            if (collection_grid) {
                collection_grid.classList.add("loading");
            }
        })
    })

    function handleNewProductCard(mutationsList) {
        mutationsList.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;

                const productCards = node.classList.contains('product-card')
                    ? [node]
                    : Array.from(node.querySelectorAll('.product-card'));

                productCards.forEach((productCard) => {
                    const trustpilotWidget = productCard.querySelector('.trustpilot-widget');
                    if (trustpilotWidget && window.Trustpilot?.loadFromElement) {
                        window.Trustpilot.loadFromElement(trustpilotWidget);
                    }

                    renderProductCardFeedingAmounts(productCard);
                });
            });
        });
    }

    const observer = new MutationObserver(handleNewProductCard);

    const config = { childList: true, subtree: true };

    // Specify the target node, or document.body by default
    const targetNode = document.body;

    observer.observe(targetNode, config);
})

// Helper to get baseUrl and sectionId from data attributes
function getCollectionGridVars() {
    const section = document.getElementById('collection-grid');
    return {
        baseUrl: section ? section.getAttribute('data-base-url') : '',
        sectionId: section ? section.getAttribute('data-section-id') : ''
    };
}

window.updateCollectionResults = function() {
    const collectionGrid = document.querySelector('.collection-grid');
    const { baseUrl, sectionId } = getCollectionGridVars();

    if (!collectionGrid) {
        return;
    }

    collectionGrid.style.opacity = '0.5';
    collectionGrid.style.pointerEvents = 'none';
    const filterParams = window.collectFilterParams();
    const url = `${baseUrl}?${filterParams}&section_id=${sectionId}`;

    // Make AJAX request
    fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.text();
        })
        .then(html => {
            // Parse the response
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            // Get the new collection grid
            const newGrid = doc.querySelector('.collection-grid');
            if (newGrid) {
                collectionGrid.innerHTML = newGrid.innerHTML;
            } else {
                console.error('New collection grid not found in response');
            }
            // Update pagination controls (Load More button)
            const newLoadMore = doc.querySelector('.custom-filter-load-more');
            const oldLoadMore = document.querySelector('.custom-filter-load-more');
            if (newLoadMore && oldLoadMore) {
                oldLoadMore.replaceWith(newLoadMore);
            } else if (oldLoadMore && !newLoadMore) {
                oldLoadMore.remove();
            } else if (newLoadMore && !oldLoadMore) {
                const gridWrapper = document.querySelector('.collection-grid-wrapper');
                if (gridWrapper) {
                    gridWrapper.appendChild(newLoadMore);
                }
            }
            // Re-attach Load More handler after AJAX update
            attachLoadMoreHandler();
            renderProductCardFeedingAmounts(collectionGrid);
            // Reset loading state
            collectionGrid.style.opacity = '1';
            collectionGrid.style.pointerEvents = 'auto';
            // Update URL without page reload
            history.pushState({}, '', buildCollectionHistoryUrl(baseUrl, filterParams));
        })
        .catch(error => {
            console.error('Error updating collection:', error);
            // Reset loading state on error
            collectionGrid.style.opacity = '1';
            collectionGrid.style.pointerEvents = 'auto';
        });
};

window.collectFilterParams = function() {
    // Use a plain array to control order
    const paramPairs = [];
    // Collect checkbox filters
    const checkboxes = document.querySelectorAll('.custom-filter-wrapper input[type="checkbox"]:checked');
    checkboxes.forEach(checkbox => {
        paramPairs.push([checkbox.name, checkbox.value]);
    });
    // Collect price range filters (these must come before sort_by)
    const minPrice = document.querySelector('.custom-filter-wrapper input.min-price-filter');
    const maxPrice = document.querySelector('.custom-filter-wrapper input.max-price-filter');
    if (minPrice && minPrice.value) {
        paramPairs.push([minPrice.name, minPrice.value]);
    }
    if (maxPrice && maxPrice.value) {
        paramPairs.push([maxPrice.name, maxPrice.value]);
    }
    // Collect sort option (must be last)
    const sortSelect = document.querySelector('.custom-filter-wrapper select[name="sort_by"]');
    if (sortSelect && sortSelect.value) {
        paramPairs.push(['sort_by', sortSelect.value]);
    }
    // Build query string in correct order
    return paramPairs.map(pair => encodeURIComponent(pair[0]) + '=' + encodeURIComponent(pair[1])).join('&');
};
